import React from 'react';
import clsx from 'clsx';
import {
  Card,
  CardContent,
  makeStyles
} from '@material-ui/core';
import Header from '../headers/Header';
// import Footer from '../footer/Footer';
import Chart from '../../img/chart.png';


const useStyles = makeStyles((theme) => ({
  pageContainer: {
    minHeight: '100%',
    marginTop: '0px'
  },
  root: {
    margin: '20px 30px',
    marginBottom: '50px',
    padding: '20px 20px'
  }
}));


const Statistics = ({className, ...rest}) => {
  const classes = useStyles();

  return (
    <div className="bloc-">
      <Header type={"client"} title={"STATISTICS"}/>
      <div className={clsx(classes.pageContainer, className)}>
        <Card
          className={classes.root}
          elevation={2}
          {...rest}
        >
          <CardContent >
            <img
              src={Chart}
              alt="statistics-chart"
              style={{
                width: '100%'
            }}/>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default Statistics ; 


